import React, { Component } from 'react';
import firebase from 'firebase';
import { translate } from 'react-i18next';
import { firebaseConnect } from 'react-redux-firebase';
import { AppView, ListSection, Input } from 'medua-components';

/* eslint-disable */
@firebaseConnect()
@translate('account')
export default class AccountPassword extends Component {

  constructor(props) {
    super(props);
    this.state = {
      error: '',
      current: '',
      new1: '',
      new2: '',
    };

    this.handleSave = this.handleSave.bind(this);
  }

  handleSave() {

    const user = firebase.auth().currentUser
    const email = this.props.auth.email;
    const password = this.state.current;
    const credential = firebase.auth.EmailAuthProvider.credential(email, password);

    user.reauthenticateWithCredential(credential).then(() =>{
      if (this.state.new1 == this.state.new2) {
        user.updatePassword(this.state.new1.toString().trim()).then(() => {
          console.log("successfully changed");
          this.props.firebase.update(
            `users/${this.props.auth.uid}/settings`, {
              default: false
            }
          )
          this.props.firebase.logout();
        })
        .catch((error) => {
          this.setState({ error: error.message })
        });
      } else {
        this.setState({ error: this.props.t('account:change-password.error.not-match') })
      }
    })
    .catch((error) => {
      this.setState({ error: error.message })
    })
  }

  render() {
    return (
      <AppView
        color="dark"
        title={ this.props.t('account:change-password.title') }
        error={ this.state.error }
        headerActionRight={[
          { key: 1, icon: 'save', action: this.handleSave }
        ]}>
        <ListSection margin padding
          accent={{ highlight: 'turquoise' }}>
          <Input
            required
            type="password"
            meta={ this.props.t('account:terms.current-password') }
            value={ this.state.current }
            placeholder="***"
            onChange={ (e) => this.setState({ current: e.target.value })} />
          <Input
            required
            type="password"
            meta={ this.props.t('account:terms.new-password') }
            value={ this.state.new1 }
            placeholder="***"
            onChange={ (e) => this.setState({ new1: e.target.value })} />
          <Input
            required
            type="password"
            meta={ this.props.t('account:terms.retype-new-password') }
            value={ this.state.new2 }
            placeholder="***"
            onChange={ (e) => this.setState({ new2: e.target.value })} />
        </ListSection>
      </AppView>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/account/password/index.jsx